<span
    class="retail-price-hint"
    *ngIf="productId"
    tabindex="0"
    role="img"
    aria-label="Retail prices by country"
    (mouseenter)="onTriggerEnter($event)"
    (mouseleave)="onTriggerLeave()"
    (focus)="onTriggerEnter($event)"
    (blur)="onTriggerLeave()"
    (click)="onTriggerClick($event)"
>
    <img src="assets/icons/retail-price-info.svg" alt="" />
</span>
